import {addNewUserIds, setUsersWithoutApprovers, setLicenseCounters, setViewerSettings} from "../common/actions";
import {setEnabledFeatures} from "../../../features/actions";
import {addTimeZoneGroups, addUserGroups, addUsers} from "../../../entities/actions";
import {prependUserIdsOrder} from "../workAssignmentsTab/actions";
import {getUserId as getTeamAssignmentsUserId} from "../../../panels/user/editTeamAssignmentsPanel/selectors";
import {closeTeamAssignmentsPanel, openTeamAssignmentsPanel} from "../../../panels/user/editTeamAssignmentsPanel/actions";
import {reloadUserData as reloadEditUserPanelData} from "../../../panels/user/editPanel/actions"
import {AdditionalDataConstants} from '../constants'

export const setStateOnPageDataReceivedAction = (data) => dispatch => {
    dispatch(setLicenseCounters(data.licenseCounters))

    if (data.allUserGroups) {
        dispatch(addUserGroups(data.allUserGroups))
    }
    if (data.allTimeZoneGroups) {
        dispatch(addTimeZoneGroups(data.allTimeZoneGroups))
    }

    dispatch(setViewerSettings(data.viewerSettings))
    dispatch(setUsersWithoutApprovers(data.usersWithoutApprovers))

    dispatch(setEnabledFeatures(data.viewerSettings.enabledFeatures))
    dispatch(addUsers(data.records))
}

export const setStateOnInviteSeveralUsersSuccess = (data) => dispatch => {
    dispatch(setLicenseCounters(data.licenseCounters))

    if (data.userGroups) {
        dispatch(addUserGroups(data.userGroups))
    }
    if (data.timeZoneGroups) {
        dispatch(addTimeZoneGroups(data.timeZoneGroups))
    }

    dispatch(setViewerSettings(data.viewerSettings))
    dispatch(setUsersWithoutApprovers(data.additionalResultData.map[AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]))

    dispatch(setEnabledFeatures(data.viewerSettings.enabledFeatures))
    const addedUsers = data.additionalUsersInfo
    const ids = addedUsers.map((user) => user.id)
    dispatch(addUsers(addedUsers))
    dispatch(addNewUserIds(ids))
    dispatch(prependUserIdsOrder(ids))
}

export const openTeamAssignmentsPanelFromUserList = (userId) => (dispatch, getState) => {
    const configuredUserId = getTeamAssignmentsUserId(getState())
    if (configuredUserId !== userId) {
        dispatch(openTeamAssignmentsPanel(userId))
        dispatch(reloadEditUserPanelData())
    } else {
        dispatch(closeTeamAssignmentsPanel())
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/actions.js